/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-09-23 10:48:39
 * @FilePath: \飞行-运控\src\api\model\flyCommission.js
 * @Description: 飞行任务模块的接口
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	ykTaskInstruction: {
		url: `${config.MAIN_URL}/api/v1/hw/ykTaskInstruction`,
		name1: "飞行任务-新增",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		name2: "飞行任务-列表查询",
		get: async function (params) {
			return await http.get(this.url,params);
		},
		name3: "飞行任务-修改",
		put: async function (data) {
			return await http.put(this.url, data);
		},
		name4: "飞行任务-删除",
		delete: async function (params) {
			return await http.delete(this.url+ params);
		},

	},
	paginQueryPt: {
		url: `${config.MAIN_URL}/api/v1/hw/ykTaskInstruction/paginQueryPt`,
		name: "我的任务-列表查询",
		get: async function (params) {
			return await http.get(this.url , params);
		},

	},
	getXfr: {
		url: `${config.MAIN_URL}/api/v1/hw/ykTaskInstruction/getXfr`,
		name: "飞行任务-查询下发人",
		get: async function (params) {
			return await http.get(this.url , params);
		},
	},
	byId: {
		url: `${config.MAIN_URL}/api/v1/hw/ykTaskInstruction/byId`,
		name: "任务-查询详情",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	confirm: {
		url: `${config.MAIN_URL}/api/v1/hw/YkIssueUser/confirm`,
		name: "我的任务-确认/完成",
		put: async function (data) {
			return await http.put(this.url,data);
		},
	},
	ykUavFlyPlan: {
		url: `${config.MAIN_URL}/api/v1/hw/ykUavFlyPlan`,
		name: "我的任务-创建计划",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	history: {
		url: `${config.MAIN_URL}/api/v1/hw/ykUavFlyPlan/history`,
		name: "我的任务-执行记录",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	dropDown: {
		url: `${config.ADSB_URL}/v1/api/uavData/dropDown`,
		name: "我的任务-无人机设备信息下拉",
		get: async function (data) {
			return await http.get(this.url,data);
		},
	},
	uavLine: {
		url: `${config.ADSB_URL}/v1/api/uavLine/dropDown`,
		name: "我的任务-航线下拉",
		get: async function (data) {
			return await http.get(this.url,data);
		},
	},
};
